import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addEmail from "./components/addEmail.vue";
import draft from "./components/draft.vue";
import { szgmEmailList, szgmdoDeleteEmail, szEmailLanguageList } from "@/api/gmToolNew/gmToolNew";
import emailDetils from "./components/emailDetils.vue";
import viewArticles from "./components/viewArticles.vue";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "gmToolNewemailq",
  components: {
    addEmail: addEmail,
    viewArticles: viewArticles,
    draft: draft,
    emailDetils: emailDetils
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      advanced: false,
      paramsData: {
        page: 1,
        page_size: 10,
        email_type: '',
        language: '',
        title: '',
        content: ''
      },
      tableData: [],
      // 表格数据
      total: 0,
      tableCopyTableList: [],
      // 表格copy数据b
      value1: ''
    };
  },
  created: function created() {},
  methods: {
    getList: function getList(page) {
      var _this = this;

      // if(!this.paramsData.server_id){
      //   this.$message.error(this.$t('pleaseSelectServer'))
      //   return
      // }
      this.paramsData.page = page ? page : this.paramsData.page;
      this.reqLoading = true;
      szgmEmailList(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.code == 200) {
          if (!res.data.data.length && _this.paramsData.page > 1) {
            _this.getList(_this.paramsData.page - 1);
          } else {
            res.data.data.map(function (item) {
              if (item.email_type == 2) {
                var email_user_ids = item.email_user_ids ? JSON.parse(item.email_user_ids) : "";

                if (Array.isArray(email_user_ids)) {
                  item.email_user_ids = email_user_ids.toString();
                } else {
                  item.email_user_ids = email_user_ids;
                }
              } else if (item.email_type == 3) {
                var d = item.email_user_ids.split(',');
                item.times = d[0] + ' ' + _this.$t('range') + ' ' + d[1];
                item.email_user_ids = '';
              }
            });
            _this.tableData = res.data.data;
            _this.total = res.data.total;
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    regeneration: function regeneration(row) {
      var data = JSON.parse(JSON.stringify(row));
      data.id = '';
      this.$refs.draft.open(data, null, true);
    },
    searchClick: function searchClick() {
      this.paramsData.page = 1;
      this.getList();
    },
    currentChaneg: function currentChaneg(e) {
      this.paramsData.page = e;
      this.getList();
    },
    // 删除配置
    deleHandle: function deleHandle(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                szgmdoDeleteEmail({
                  id: id,
                  server_id: _this2.paramsData.server_id,
                  env_id: _this2.paramsData.env_id
                }).then(function (res) {
                  _this2.getList();

                  _this2.$message({
                    type: "success",
                    message: _this2.$t('operationSuccess')
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};